export class GenerateLensSeparationListReportInput {
  orderIds: number[];
  title: string;
}